import styled from 'styled-components'
import { DARK_VIOLET, GRAYSCALE_500, NEUTRAL_100, PALE_BLUE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 12px;
    border: 1px solid ${NEUTRAL_100};
    background-color: ${PALE_BLUE};
    border-radius: 8px;
`

export const CardTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const CalculatorIconContainer = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    border: none;
    appearance: none;
    padding: 0;
    cursor: pointer;
`

export const TitleText = styled.span`
    color: ${GRAYSCALE_500};
    font-family: ${INTER.medium};
`

export const ConversionText = styled.span`
    color: ${DARK_VIOLET};
    font-family: ${INTER.regular};
`
